import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MsgService } from './msg.service';
import { MpsLoaderService } from '../../../../mps/services/mps-loader.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  public _endpoint: string;
  private _headers: HttpHeaders;

  constructor(
    public _msgService: MsgService,
    public _http: HttpClient,
    public _loader: MpsLoaderService,
  ) {
    this._endpoint = environment.api.host;
    this._headers = new HttpHeaders({
      'Accept-Language': 'fr, en',
    });
  }

  get<T>(resource: string, params: any = {}): Observable<T> {
    params.headers = new HttpHeaders({
      'Accept-Language': 'fr, en',
    });

    return this._http.get<T>(this._endpoint + '/' + resource, params).pipe(
      catchError(this.handleError)
    ) as Observable<T>;
  }

  post<S,T>(resource: string, params?: T | S, options: any = {}): Observable<T> {
    if (!resource.indexOf('register')) {
      options.headers = new HttpHeaders({
        'Accept-Language': 'fr, en',
      });
    }
    return this._http.post<T>(this._endpoint + '/' + resource, params, options).pipe(
      catchError(this.handleError)
    ) as Observable<T>;
  }

  patch<S,T>(resource: string, params?: T | S, options: any = {}): Observable<T> {

    return this._http.patch<T>(this._endpoint + '/' + resource, params, options).pipe(
      catchError(this.handleError)
    ) as Observable<T>;
  }

  delete<T>(resource: string, params?: object): Observable<T> {
    return this._http.delete<T>(this._endpoint + '/' + resource, params).pipe(
      catchError(this.handleError)
    ) as Observable<T>;
  }

  private handleError<T>(error: any): Promise<T> {
    // console.error('An error occurred', error); // for demo purposes only
    if (error.status === 422) {
      return Promise.reject(error.error);
    }
    console.log(error);
    return Promise.reject(error?.error?.message || error?.message || error);
  }

}
